var tabs = (function( $ ) {

	var anim_speed = 800;

	var _init = function() {
		_setup_triggers();
	}

	var _setup_triggers = function() {
		var $desktop_tabs = $( '.desktop-tabs-wrapper' );
		var $mobile_tabs = $( '.mobile-tabs-wrapper' );

		$desktop_tabs.find( 'a.tab-link' ).on( 'click', function( e ) {
			e.preventDefault();

			if ( ! $( this ).hasClass( 'active' ) ) {
				toggle_tab_desktop( $( this ).data( 'tab-id' ), $desktop_tabs );
			}
		} );

		$mobile_tabs.find( 'a.tab-link' ).on( 'click', function( e ) {
			e.preventDefault();

			if ( ! $( this ).hasClass( 'active' ) ) {
				toggle_tab_mobile( $( this ).data( 'tab-id' ), $mobile_tabs );
			}
		} );
	}

	function toggle_tab_desktop( tab_index, $wrapper ) {
		if ( $wrapper.hasClass( 'animating' ) ) {
			return;
		}

		$wrapper.addClass( 'animating' );

		var $active = $wrapper.find( '.tab-title a.active' );

		if ( $active.length > 0 ) {
			close_tab_desktop( $active, $wrapper, anim_speed / 2 );

			setTimeout( () => {
				open_tab_desktop( $wrapper.find( 'a.tab-link[data-tab-id="' + tab_index + '"' ), $wrapper, anim_speed / 2 );
			}, anim_speed / 2 )
		} else {
			open_tab_desktop( $wrapper.find( 'a.tab-link[data-tab-id="' + tab_index + '"' ), $wrapper );
		}

		setTimeout( () => {
			$wrapper.removeClass( 'animating' );
		}, anim_speed );
	}

	var close_tab_desktop = function( $tab_link, $wrapper, animation_speed ) {
		let $tab = $wrapper.find( '.tab-content.active' );
		$tab.fadeOut( animation_speed ? animation_speed : anim_speed );

		setTimeout( () => {
			$tab.removeClass( 'active' );
			$tab_link.removeClass( 'active' );
		}, animation_speed ? animation_speed : anim_speed );
	}

	var open_tab_desktop = function( $tab_link, $wrapper, animation_speed ) {
		let $tab = $wrapper.find( '.tab-content[data-tab-id="' + $tab_link.data( 'tab-id' ) + '"]' );
		$tab.fadeIn( animation_speed ? animation_speed : anim_speed );

		setTimeout( () => {
			$tab.addClass( 'active' );
			$tab_link.addClass( 'active' );
		}, animation_speed ? animation_speed : anim_speed );
	}

	function toggle_tab_mobile( tab_index, $wrapper ) {
		if ( $wrapper.hasClass( 'animating' ) ) {
			return;
		}

		$wrapper.addClass( 'animating' );

		var $active = $wrapper.find( '.accordion-title a.active' );

		if ( $active.length > 0 ) {
			close_tab_mobile( $active, $wrapper, anim_speed / 2 );

			setTimeout( () => {
				open_tab_mobile( $wrapper.find( 'a.tab-link[data-tab-id="' + tab_index + '"' ), $wrapper, anim_speed / 2 );
			}, anim_speed / 2 )
		} else {
			open_tab_mobile( $wrapper.find( 'a.tab-link[data-tab-id="' + tab_index + '"' ), $wrapper );
		}

		setTimeout( () => {
			$wrapper.removeClass( 'animating' );
		}, anim_speed );
	}

	function close_tab_mobile( $tab_link, $wrapper, animation_speed ) {
		let $tab = $wrapper.find( '.accordion-content.active' );
		$tab.slideUp( animation_speed ? animation_speed : anim_speed );

		setTimeout( () => {
			$tab.removeClass( 'active' );
			$tab_link.removeClass( 'active' );
		}, animation_speed ? animation_speed : anim_speed );
	}

	var open_tab_mobile = function( $tab_link, $wrapper, animation_speed ) {
		let $tab = $wrapper.find( '.accordion-content[data-tab-id="' + $tab_link.data( 'tab-id' ) + '"]' );
		$tab.slideDown( animation_speed ? animation_speed : anim_speed );

		setTimeout( () => {
			$tab.addClass( 'active' );
			$tab_link.addClass( 'active' );
		}, animation_speed ? animation_speed : anim_speed );
	}

	if ( $( '#single-attended-course-wrapper' ).length > 0 ) {
		$( document ).ready( _init );
	}

	return {};

})( jQuery );

module.exports = tabs;